import { AxiosResponse } from 'axios';
import { DOCUMENT_STORE_TENANT_ID } from 'config';
import { UploadToStorageRequest } from './types';

export const getTotalBytes = (files: File[]): number =>
  files.reduce((totalSize, currentFile) => totalSize + currentFile.size, 0);

export const parseStorageUploadRequest = (uploadRequest: UploadToStorageRequest): FormData => {
  const { groupingReference, file, metadata, overwriteExistingFile } = uploadRequest;

  const formData = new FormData();
  formData.append('documentStoreTenantId', DOCUMENT_STORE_TENANT_ID);
  formData.append('groupingReference', groupingReference);
  formData.append('file', file);
  formData.append('overwriteExistingFile', String(overwriteExistingFile));

  Object.keys(metadata).forEach((key) => formData.append(`Metadata[${key}]`, metadata[key]));

  return formData;
};

/**
 * Tries to parse a header from the provided AxiosResponse, throwing a TypeError if not present.
 * @param response Response to parse.
 * @param header Header to fetch.
 * @returns Contents of requested header.
 */
export const parseHeader = (response: AxiosResponse, header: string): string => {
  if (!response.headers) {
    throw new TypeError('No headers exist within the response.');
  }

  const headerKey = Object.keys(response.headers).filter((k) => k.toLowerCase() === header)[0];

  if (!headerKey) {
    throw new TypeError(`Header '${header}' is not present within the provided response.`);
  }

  return response.headers[headerKey];
};
